export type StoreyName = {
    id: number;
    translationKey: string;
};

const translationKeyPrefix = 'plans/annotation/toolbar/storey-selecting/storeys';

export const storeyNames: StoreyName[] = [
    { id: 1, translationKey: `${translationKeyPrefix}/floor-plan` },
    { id: 4, translationKey: `${translationKeyPrefix}/entrence-level` },
    { id: 6, translationKey: `${translationKeyPrefix}/middle-floor` },
    { id: 7, translationKey: `${translationKeyPrefix}/upper-flor` },
    { id: 8, translationKey: `${translationKeyPrefix}/attic` },
    { id: 2, translationKey: `${translationKeyPrefix}/cellar` },
    { id: 3, translationKey: `${translationKeyPrefix}/basement` },
    { id: 5, translationKey: `${translationKeyPrefix}/lower-floor` },
    { id: 9, translationKey: `${translationKeyPrefix}/alternative-floor-plan` },
    { id: 10, translationKey: `${translationKeyPrefix}/current-floor-plan` }
];

export const defaultStoreyId = storeyNames[0].id;
